import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@material-ui/core';
import numberFormatter from '../../../utils/numberFormatter';

const ApplicationTableRow = ({ application, leftAction, rightAction, categoriesEnabled, subcategoriesEnabled }) => (
  <TableRow>
    {leftAction && <TableCell padding="none" style={{ width: 60 }} className="project-row-checkbox">{leftAction}</TableCell>}
    <TableCell className="project-row" align="center">
      <span className="project-name">{application.number}</span>
    </TableCell>
    <TableCell className="project-row" style={{ width: '100%' }}>
      <span className="project-name">{application.title}</span>
    </TableCell>
    {categoriesEnabled && <TableCell className="project-row">{application.category}</TableCell>}
    {subcategoriesEnabled && <TableCell className="project-row">{application.subcategory}</TableCell>}
    <TableCell align="right" className="project-row">
      {numberFormatter.format(application.cost)}&nbsp;zł
    </TableCell>
    {rightAction && <TableCell align="right" className="project-row">{rightAction}</TableCell>}
  </TableRow>
);

ApplicationTableRow.propTypes = {
  application: PropTypes.object.isRequired,
  leftAction: PropTypes.node,
  rightAction: PropTypes.node,
  categoriesEnabled: PropTypes.bool,
  subcategoriesEnabled: PropTypes.bool,
};

export default ApplicationTableRow;


// WEBPACK FOOTER //
// ./src/components/budget/types/ApplicationTableRow.js